import { Stack, Tooltip, Typography } from '@mui/material'
import { WarningAmberOutlined } from '@mui/icons-material'
import { quoteLineType } from '../../types'
import { PRODUCT_CATEGORY_SOURCE_LABELS } from './productCategories'
import { AiClassifyingLabel } from './AiClassifyingLabel'

const REVIEW_BELOW = 0.85

export function ProductCategoryCell({ item }: { item: quoteLineType }) {
  const name = item.ProductCategory
  const source = item.ProductCategorySource ?? ''
  const confidence = item.ProductCategoryConfidence
  const needsReview =
    source === 'FALLBACK' ||
    (source !== 'MANUAL' && confidence !== null && confidence !== undefined && confidence < REVIEW_BELOW)
  const sourceLabel = source in PRODUCT_CATEGORY_SOURCE_LABELS ? PRODUCT_CATEGORY_SOURCE_LABELS[source] : source
  const tooltip = [
    sourceLabel,
    confidence !== null && confidence !== undefined && source !== 'MANUAL'
      ? `${Math.round(confidence * 100)}% confidence`
      : null,
  ]
    .filter(Boolean)
    .join(' · ')

  if (!name) {
    return source === 'PENDING_AI' ? <AiClassifyingLabel /> : <Typography variant="body2">-</Typography>
  }

  return (
    <Tooltip title={tooltip}>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {needsReview && <WarningAmberOutlined fontSize="small" color="warning" />}
        <Typography variant="body2" className="lines-ellipsis-col">
          {name}
        </Typography>
      </Stack>
    </Tooltip>
  )
}
